var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('script'),_vm._v(" "),_c(_vm.PAGES_MAP[_vm.getPageType],{tag:"component",attrs:{"urlInfo":_vm.getUrlInfo}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }